import React from "react";
import { TripChecklist } from "../types";
import TripEmptyState from "../emptyState";
import { hasChecklistContent } from "../utils";

const ChecklistGroup = ({
  title,
  items,
}: {
  title: string;
  items: string[];
}) => {
  if (!items.length) return null;

  return (
    <div className="trip-checklist-group">
      <h3 className="trip-checklist-group-title">{title}</h3>
      <ul className="trip-checklist-items">
        {items.map((item, index) => (
          <li key={`${title}-${index}`}>{item}</li>
        ))}
      </ul>
    </div>
  );
};

const TripChecklistSection = ({
  checklist,
}: {
  checklist?: TripChecklist;
}) => {
  const hasData = hasChecklistContent(checklist);
  const dayEntries = Object.entries(checklist?.days || {}).filter(
    ([, items]) => items?.length
  );
  const planEntries = Object.entries(checklist?.tripPlans || {}).filter(
    ([, items]) => items?.length
  );

  return (
    <section className="trip-section">
      <div className="trip-section-header">
        <h2 className="trip-section-title">Checklist</h2>
        {checklist?.completionLevel != null ? (
          <span className="trip-completion">
            {checklist.completionLevel}% complete
          </span>
        ) : null}
      </div>

      {!hasData ? (
        <TripEmptyState message="No checklist data available" />
      ) : (
        <>
          {dayEntries.length > 0 ? (
            <div className="trip-checklist-block">
              <h3 className="trip-checklist-subtitle">Daily plan</h3>
              {dayEntries.map(([day, items]) => (
                <ChecklistGroup key={day} title={day} items={items} />
              ))}
            </div>
          ) : null}

          {planEntries.length > 0 ? (
            <div className="trip-checklist-block">
              <h3 className="trip-checklist-subtitle">Trip plans</h3>
              {planEntries.map(([label, items]) => (
                <ChecklistGroup key={label} title={label} items={items} />
              ))}
            </div>
          ) : null}
        </>
      )}
    </section>
  );
};

export default TripChecklistSection;
